import type { HelpFile } from '../../types/help'
import { ResourceDetailTestIds } from '../../../testids/ResourceDetailTestIds'

export const resourceDetailHelp: HelpFile = {
  docPage: '/docs/systems/resources',
  texts: {
    [ResourceDetailTestIds.resourceDetailPage]: 'Protected resource detail — attributes, owners, child resources, enforcement objects, and related access profiles.',
    [ResourceDetailTestIds.cardResourceDetails]: 'Core attributes: name, type, classification, and parent system.',
    [ResourceDetailTestIds.btnDeleteResource]: 'Delete this resource. Refused with 409 when any child resources or enforcement objects still reference the resource.',
    [ResourceDetailTestIds.linkParentResource]: 'Open the parent resource in the hierarchy.',
    [ResourceDetailTestIds.linkSystem]: 'Open the target system that owns this resource.',
    [ResourceDetailTestIds.sectionAccessProfiles]: 'Access profiles that grant access to this resource.',
    [ResourceDetailTestIds.sectionAttributes]: 'Custom attributes defined for this resource.',
    [ResourceDetailTestIds.sectionChildren]: 'Child resources nested under this one in the hierarchy.',
    [ResourceDetailTestIds.sectionEnforcementObjects]: 'Enforcement objects — accounts, group memberships — that materialise access on the target system.',
    [ResourceDetailTestIds.colChildDataClassification]: 'Data classification of the child resource — public, internal, or confidential.',
    [ResourceDetailTestIds.colChildName]: null,
    [ResourceDetailTestIds.colChildResourceType]: 'Resource type of the child entry.',
    [ResourceDetailTestIds.colEoName]: null,
    [ResourceDetailTestIds.colEoSystem]: 'Target system that hosts this enforcement object.',
    [ResourceDetailTestIds.colEoType]: 'Enforcement object type — account, group, or role.',
    [ResourceDetailTestIds.colProfileName]: null,
    [ResourceDetailTestIds.colProfileRisk]: 'Risk level associated with this access profile.',
    [ResourceDetailTestIds.colProfileSource]: 'Whether the profile is defined on this resource or inherited from a parent.',
    [ResourceDetailTestIds.colProfileStatus]: 'Whether this access profile is active and currently grantable.',
  },
}
